import { TIER_IDS } from './Tiers';

const TierPaidSubtitle = 'Onbeperkt toegang tot alle series films en programma’s';

export const TierPresentations = {
	[TIER_IDS.FREE]: {
		title: 'TV Gemist',
		subtitle: 'Kijk tot 7 dagen je favoriete RTL programma’s terug',
		features: [
			{
				icon: 'times',
				description: 'Met reclame',
				description_no_icon: 'Met reclame',
			},
			{
				icon: 'users',
				description: '1 apparaat tegelijk, op 1 adres',
				description_no_icon: '1 apparaat tegelijk, op 1 adres',
			},
			{
				icon: 'times',
				description: 'Geen Download-to-go',
				description_no_icon: 'Geen download-to-go',
			},
			{
				description_no_icon: 'Geen Live tv',
			},
		],
	},
	[TIER_IDS.ESSENTIAL]: {
		title: 'Basis',
		subtitle: TierPaidSubtitle,
		features: [
			{
				icon: 'times',
				description: 'Met reclame',
				description_no_icon: 'Met reclame',
			},
			{
				icon: 'users',
				description: '1 apparaat tegelijk, op 1 adres',
				description_no_icon: '1 apparaat tegelijk, op 1 adres',
			},
			{
				icon: 'times',
				description: 'Geen Download-to-go',
				description_no_icon: 'Geen download-to-go',
			},
			{
				description_no_icon: 'Live tv',
			},
		],
	},
	[TIER_IDS.STANDARD]: {
		title: 'Plus',
		subtitle: TierPaidSubtitle,
		features: [
			{
				icon: 'checkmark',
				description: 'reclamevrij',
				description_no_icon: 'reclamevrij',
			},
			{
				icon: 'users',
				description: '2 apparaten tegelijk, op 1 adres',
				description_no_icon: '2 apparaten tegelijk, op 1 adres',
			},
			{
				icon: 'checkmark',
				description: 'Download-to-go',
				description_no_icon: 'Download-to-go',
			},
			{
				description_no_icon: 'Live tv',
			},
		],
	},
	[TIER_IDS.PREMIUM]: {
		title: 'Premium',
		subtitle: TierPaidSubtitle,
		features: [
			{
				icon: 'checkmark',
				description: 'reclamevrij',
				description_no_icon: 'reclamevrij',
			},
			{
				icon: 'users',
				description: '4 apparaten tegelijk, op 1 adres',
				description_no_icon: '4 apparaten tegelijk, op 1 adres',
			},
			{
				icon: 'checkmark',
				description: 'Download-to-go',
				description_no_icon: 'Download-to-go',
			},
			{
				description_no_icon: 'Live tv',
			},
		],
	},
	[TIER_IDS.PREMIUM_WITH_ADS]: {
		title: 'Premium met reclame',
		subtitle: TierPaidSubtitle,
		features: [
			{
				icon: 'users',
				description: '4 apparaten tegelijk, op 1 adres',
				description_no_icon: '4 apparaten tegelijk, op 1 adres',
			},
			{
				icon: 'checkmark',
				description: 'Download-to-go',
				description_no_icon: 'Download-to-go',
			},
			{
				description_no_icon: 'Live tv',
			},
		],
	},
	[TIER_IDS.STANDARD_WITH_ADS]: {
		title: 'Plus met reclame',
		subtitle: TierPaidSubtitle,
		features: [
			{
				icon: 'users',
				description: '2 apparaten tegelijk, op 1 adres',
				description_no_icon: '2 apparaten tegelijk, op 1 adres',
			},
			{
				icon: 'checkmark',
				description: 'Download-to-go',
				description_no_icon: 'Download-to-go',
			},
			{
				description_no_icon: 'Live tv',
			},
		],
	},
	[TIER_IDS.LEGACY]: {
		title: 'Legacy',
		subtitle: TierPaidSubtitle,
		features: [
			{
				icon: 'checkmark',
				description: 'reclamevrij',
				description_no_icon: 'reclamevrij',
			},
			{
				icon: 'users',
				description: '4 apparaten tegelijk, op 1 adres',
				description_no_icon: '4 apparaten tegelijk, op 1 adres',
			},
			{
				icon: 'checkmark',
				description: 'Download-to-go',
				description_no_icon: 'Download-to-go',
				description_list_item: 'Live tv',
			},
			{
				description_no_icon: 'Live tv',
			},
		],
	},
	[TIER_IDS.HBO_ESSENTIAL]: {
		title: 'Videoland Basis & HBO Max Basic',
	},
	[TIER_IDS.HBO_STANDARD]: {
		title: 'Videoland Plus & HBO Max Standaard',
	},
	[TIER_IDS.HBO_PREMIUM]: {
		title: 'Videoland Premium & HBO Max Premium',
	},
};
